import { Pipe, PipeTransform } from '@angular/core';
import { LANG_SELECTED } from "../app.const";
import { UserService } from '../services/user.service';

@Pipe({
  name: 'localefilter'
})
export class LocalefilterPipe implements PipeTransform {

  constructor(private user: UserService) {}

  transform(value: Array<any>, filter: string = '', property: string, key: string, backupKey: string = null): any {
    if (!value || !Array.isArray(value)) return [];
    if (!filter) filter = '';

    return value.filter(val => {

      // MAIN PROPERTY AVAILABLE?
      if (val[property]) {

        const localized = val[property].find(obj => obj.locale === this.user.currentLanguage);

        const objToUse = localized || val[property][0];

        if (objToUse && objToUse[key]) {
          return objToUse[key].toString().toLowerCase().includes(filter.toLowerCase());
        }

        return false;
      }

      // BACKUP KEY AVAILABLE?
      if (backupKey && val[backupKey]) {
        return val[backupKey].toString().toLowerCase().includes(filter.toLowerCase());
      }

      return false;
    });
  }
}
